// Gerado automaticamente — não editar manualmente
export const buildInfo = {
  version: '2.7.1',
  buildDate: '24/08/2026 12:44',
  gitHash: 'a0cc26bb'
};
